// @flow
import React from "react"
import { Wrap, IconWrap, Text } from "./styled"

type Props = {
  planTitle?: string,
}

const PlanIcon = ({ planTitle = "Perks" }: Props) =>
  <Wrap>
    <IconWrap>
      <Text>{planTitle}</Text>
    </IconWrap>
  </Wrap>

export default PlanIcon



// WEBPACK FOOTER //
// ./src/components/PlanIcon/index.js